export default "__VITE_ASSET__F2gmNH5K__"